var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsGoogledrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5321 4.76437C31.8523 4.76437 26.488 4.82854 26.5233 4.91517C26.5554 4.97933 32.0031 14.5434 38.6315 26.1543L50.6949 47.2459H62.7582C69.4348 47.2459 74.7991 47.1817 74.7638 47.0951C74.7477 47.031 69.284 37.4669 62.6523 25.856L50.589 4.76437H38.5321ZM23.2604 10.3148C19.3472 17.0547 15.4651 23.8126 11.6142 30.5883L0 50.9098L6.06375 61.4909L12.1115 72.0688L23.7256 51.744L35.3334 31.4353L29.3017 20.8895C25.9875 15.092 23.2765 10.334 23.2604 10.3148ZM30.508 50.9098L29.8567 52.0263C29.491 52.6616 26.7767 57.3907 23.8251 62.5721C22.022 65.7557 20.2061 68.932 18.3773 72.1009C18.3453 72.1843 28.7723 72.2356 41.5479 72.2356H64.7891L70.5512 62.1069C73.7339 56.5437 76.4867 51.744 76.6663 51.4456L77 50.9098H53.7428H30.508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsGoogledrive);
export default __webpack_public_path__ + "static/media/simple-icons_googledrive.c25e8ca4a4cdabf8e2d18ce0098e46c4.svg";
export { ForwardRef as ReactComponent };